<template>
<div class="wrapper" id="app">
  <CardForm :callBack="callBack" :form-data="formData" @input-card-number="updateCardNumber" @input-card-name="updateCardName" @input-card-month="updateCardMonth" @input-card-year="updateCardYear" @input-card-cvv="updateCardCvv" />
  <!-- backgroundImage="https://images.unsplash.com/photo-1572336183013-960c3e1a0b54?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80" -->
</div>
</template>

<script>
import CardForm from '@/components/CardForm'
export default {
  name: 'app',
  components: {
    CardForm
  },
  data() {
    return {
      formData: {
        cardName: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: ''
      }
    }
  },
  methods: {
    callBack({ card, token }) {
      console.log(`card form submitted with token ${token}`)
      let payload = {card,token}
      console.log(`dispatching payload to step 3`)
      this.$store.dispatch('setup/step3', payload)
    },
    updateCardNumber(val) {},
    updateCardName(val) {},
    updateCardMonth(val) {},
    updateCardYear(val) {},
    updateCardCvv(val) {}
  },
  created() {
    this.$store.dispatch('auth/fetchUser')
  }
}
</script>

<style lang="scss">
@import '@/assets/card.scss';
</style>
